export const DEFAULTS = {
  BPM: 120,
  STEP_COUNT: 16,
  VOLUME_DB: -10,
  VOLUME_MIN: -40,
  VOLUME_MAX: 0,
  FILTER_FREQ: 20000,
  FILTER_Q: 1,
};

export const LOOPS_CONFIG = [
  { id: 'loop1', label: 'Synth Arp' },
  { id: 'loop2', label: 'Piano' },
  { id: 'loop3', label: 'Techno' },
  { id: 'loop4', label: 'Ambient Pad' },
  { id: 'loop5', label: 'Pluck Synth' },
  { id: 'loop6', label: 'Glitchy Perc' },
];

export const USER_LOOP_CONFIG = {
  MAX_USER_LOOPS: 8,
};
